/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { BakendHttpResponse } from '../../bakend-http-response';
import { RequestBuilder } from '../../request-builder';

import { BackendActualOtherOpexDto } from '../../models/backend-actual-other-opex-dto';
import { BackendActualOtherOpexRequestDto } from '../../models/backend-actual-other-opex-request-dto';

export interface MonitoringActualsOtherOpexesCreate$Params {
  /**
   * ID сценария для фильтрации списка
   */
  scenario_id?: number;

  /**
   * Поиск по текстовым полям сущности
   */
  search?: string;
  body: BackendActualOtherOpexRequestDto;
}

export function monitoringActualsOtherOpexesCreate(
  http: HttpClient,
  rootUrl: string,
  params: MonitoringActualsOtherOpexesCreate$Params,
  context?: HttpContext,
): Observable<BakendHttpResponse<BackendActualOtherOpexDto>> {
  const rb = new RequestBuilder(rootUrl, monitoringActualsOtherOpexesCreate.PATH, 'post');
  if (params) {
    rb.query('scenario_id', params.scenario_id, {});
    rb.query('search', params.search, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as BakendHttpResponse<BackendActualOtherOpexDto>;
    }),
  );
}

monitoringActualsOtherOpexesCreate.PATH = '/api/monitoring/actuals/other-opexes/';
